module.exports = __webpack_public_path__ + "img/self_assess.74015ca8.png";